import { FollowList } from '@interfaces/auth';

interface AllLeagueTeamsSession {
  user?: {
    follow?: FollowList;
    token?: {
      accessToken?: string;
    };
  };
}

export const getAllLeagueTeamsAuth = (
  session?: AllLeagueTeamsSession | null
) => ({
  favorites: session?.user?.follow,
  userToken: session?.user?.token?.accessToken,
});
